<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="609"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  Save Ration(s)
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="py-10 black--text text-center">
                <v-btn fab depressed color="green2" class="my-4">
                  <v-icon color="green">mdi-check</v-icon>
                </v-btn>
                <p class="font-weight-bold">
                  {{ noOfSavedRations }} Ration(s) have been saved successfully.
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    dialog() {
      return this.dialogU;
    },
  },
  props: {
    dialogU: {
      type: Boolean,
      required: true,
    },
    noOfSavedRations: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$router.push({ name: "RationLibrary" });
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
::v-deep .v-input__control {
  margin: 0 -2px;
  border: 0;
}
::v-deep .v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}
</style>
